// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'
import ImageOverlay from 'church-theme-library/components/Image/ImageOverlay'
import ShareLinks from 'church-theme-library/components/Share/ShareLinks'
import SermonVideo from 'church-theme-library/pages/SermonVideo'
import { formattedDate } from 'church-theme-library/utilities/date'
import Editable from 'church-theme-library/components/Editable/Editable'

class PageHeader extends React.Component {
	renderContent() {
		const { translate, type, selectedArchive } = this.props
		let page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		let showCategory = true

		if ( selectedArchive ) {
			page = selectedArchive
		}

		if ( ! page ) {
			return null
		}

		if ( 'event' == type ) {
			showCategory = false
		}

		// Author:
		let authorsMarkup = null,
			authorsNumber,
			authorsClass

		if ( 'post' == type && page.authors && page.authors.by_id ) {
			authorsNumber = Object.keys( page.authors.by_id ).length
			authorsClass = '-authors'

			if ( authorsNumber > 1 ) {
				authorsClass += ' has-multiple'
			}

			authorsMarkup = Object.keys( page.authors.by_id ).map( ( key ) => {
				let item = page.authors.by_id[ key ]

				return (
					<span className="-author" key={ key }>
						{ item.name }
					</span>
				)
			} )
		} else if ( 'sermon' == type && page.preacher_name ) {
			authorsClass = '-authors'

			authorsMarkup = (
				<span className="-author">
					{ page.preacher_name }
				</span>
			)
		}

		// Views:
		let views,
			viewsText

		if ( 'post' == type || 'sermon' == type ) {
			views = parseInt( page.views, 10 )

			if ( ! views ) {
				views = 0
			}

			views++ // Include this view.

			viewsText = translate(
				'%(numberOfViews)d View',
				'%(numberOfViews)d Views',
				{
					count: views,
					args: {
						numberOfViews: views
					}
				}
			)
		}

		let editableIdTitle = 'page_title'

		if ( 'sermon-series' == type ) {
			editableIdTitle = 'sermon_series_title'
		}

		return (
			<div className="-text">
				<div className="-title">
					{ showCategory && page.category && page.category.primary.name &&
						<p className="-category" dangerouslySetInnerHTML={ { __html: page.category.primary.name } } />
					}

					{ 'before_title' == page.page_header_show_subtitle &&
						<Editable
							id="page_subtitle"
							element="h2"
							className="editor-text-is-centered"
							content={ page.subtitle }
						/>
					}

					<Editable
						id={ editableIdTitle }
						element="h1"
						className=""
						content={ page.title.raw }
					/>

					{ 'after_title' == page.page_header_show_subtitle &&
						<Editable
							id="page_subtitle"
							element="h2"
							className="editor-text-is-centered"
							content={ page.subtitle }
						/>
					}
				</div>

				{ ( 'post' == type || 'sermon' == type ) &&
					<div className="-meta">
						{ authorsMarkup &&
							<div className={ authorsClass }>
								{/*<span className="-by">{ translate( 'Written by' ) }</span> */}
								{ authorsMarkup }
							</div>
						}

						{ page.date &&
							<div className="-date">
								{ formattedDate( page ) }
							</div>
						}
					</div>
				}
			</div>
		)
	}

	renderImage() {
		const { type, match, selectedArchive } = this.props
		let wrapClass = '-image'

		// Get page:
		let page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( selectedArchive ) {
			page = selectedArchive
		}

		if ( ! page || ! page.featured_image ) {
			return null
		}

		const featuredImage = page.featured_image

		// Sermon:
		if ( 'sermon' == type ) {
			return <SermonVideo />
		}

		// Styles:
		// Show thin images at full width:
		// if ( page.featured_image.aspect_ratio > 1.77 ) {
			wrapClass += ' is-extra-wide'
		// }

		let imageWrapStyle = {}

		// Ratio:
		if ( page.featured_image.aspect_ratio ) {
			imageWrapStyle = {
				paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
			}
		}

		// Overlay:
		let showOverlay = false

		if ( ! selectedArchive && 'text_over_image' == page.page_header_style ) {
			showOverlay = true
		}

		// Edit data:
		let editableId = 'page_featured_image'

		if ( 'sermon-series' == type ) {
			editableId = 'sermon_series_featured_image'
		}

		if ( featuredImage.url ) {
			return (
				<Editable
					id={ editableId }
					className={ wrapClass }
				>
					<Image
						thumb={ featuredImage.thumb }
						url={ featuredImage.url }
						srcset={ featuredImage.srcset }
						srcsetWebp={ featuredImage.srcset_webp }
						sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
						alt={ featuredImage.alt }
						focalPoint={ featuredImage.focal_point }
						width={ featuredImage.width }
						height={ featuredImage.height }
						wrapStyle={ imageWrapStyle }
					/>
				</Editable>
			)
		}

		return null
	}

	render() {
		const { selectedArchive } = this.props
		let page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( selectedArchive ) {
			// page = selectedArchive
			return null
		}

		if ( ! page ) {
			return null
		}

		if ( 'page' == page.post_type ) {
			return null
		}

		let imageMarkup = this.renderImage()
		let className = 'section-hero page-header'

		if ( imageMarkup ) {
			className += ' with-image'
		} else {
			className += ' without-image'
		}

		if ( this.props.isLoading ) {
			return null
		} else {
			return (
				<div className="page-section-hero">
					<div className={ className }>
						<div className="-inner">
							{ imageMarkup }
							{ this.renderContent() }
						</div>
					</div>
				</div>
			)
		}

	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive
	}
}

export default localize(
	connect( mapStateToProps )( PageHeader )
)
